import { Card as CardANTD } from "antd";
import styled from "styled-components";

export const Card = styled(CardANTD)`
  box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.08);
  background: ${({ theme }) => theme.colors.modalBackgroundColor};
  border-radius: 8px;

  margin-bottom: 40px;
  border: none;

  &,
  .ant-card-head {
    border-color: ${({ theme }) => theme.colors.backgroundColor};
  }

  .ant-card-head-title {
    color: ${({ theme }) => theme.colors.textColor};
  }
`;
